<template>
  <div class="container">
    <el-card>
      <div class="filter-container">
        <span class="search-label">自定义检索：</span>
        <el-select size="small" v-model="searchType" @change="handleSearchTypeChange">
          <el-option label="按保险条款名称" value="1" />
          <el-option label="按保险条款状态" value="3" />
        </el-select>
        
        <el-input
          v-if="searchType === '1'"
          size="small"
          v-model="searchKeywords.name"
          placeholder="保险条款名称"
          maxlength="100"
          style="width: 200px; margin-left: 10px"
        />
        
        <el-select
          v-if="searchType === '3'"
          size="small"
          v-model="searchKeywords.disabled"
          placeholder="请选择状态"
          style="width: 150px; margin-left: 10px"
        >
          <el-option label="启用" value="false" />
          <el-option label="禁用" value="true" />
        </el-select>

        <el-button size="small" @click="handleSearch" style="margin-left: 10px">搜索</el-button>
        <el-button size="small" @click="handleShowAll">全部</el-button>

        <div class="right-buttons">
          <el-button size="small" @click="handleExport">导出 Excel</el-button>
          <el-button size="small" type="primary" @click="handleAdd">添加</el-button>
        </div>
      </div>
    </el-card>

    <el-card style="margin-top: 15px">
      <el-table
        ref="table"
        border
        size="small"
        :data="tableData.rows"
        :height="tableHeight"
        :header-cell-style="{ backgroundColor: '#f7f7f7', color: '#333' }"
      >
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column show-overflow-tooltip prop="name" label="保险条款名称" min-width="200" align="center" />
        <el-table-column show-overflow-tooltip prop="id" label="保险条款Id" width="120" align="center" />
        <el-table-column show-overflow-tooltip prop="disabled" label="状态" width="80" align="center" :formatter="formatStatus" />
        <el-table-column show-overflow-tooltip prop="created_at" label="创建时间" min-width="150" align="center" :formatter="formatDate" />
        <el-table-column show-overflow-tooltip prop="updated_at" label="更新时间" min-width="150" align="center" :formatter="formatDate" />
        <el-table-column label="操作" width="280" align="center">
          <template slot-scope="{ row }">
            <div>
              <el-button v-if="row.disabled" size="mini" @click="handleToggleStatus(row, false)">启用</el-button>
              <el-button v-else size="mini" @click="handleToggleStatus(row, true)">禁用</el-button>
              <el-button size="mini" @click="handleEdit(row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(row.id)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        :total="tableData.total"
        :page.sync="pagination.page"
        :rows.sync="pagination.rows"
        @pagination="handleGetList"
      />
    </el-card>

    <ClauseEditDialog
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      :form-data="editFormData"
      @save="handleSave"
    />
  </div>
</template>

<script>
import pagination from '@/components/Pagination'
import ClauseEditDialog from './components/ClauseEditDialog.vue'
import { getInsuranceClauseList, deleteInsuranceClause, saveInsuranceClause } from '@/api/product'

export default {
  name: 'ClauseConfig',
  components: {
    pagination,
    ClauseEditDialog
  },
  data() {
    return {
      tableHeight: 400,
      searchType: '1',
      searchKeywords: {
        name: '',
        disabled: ''
      },
      pagination: {
        page: 1,
        rows: 15,
        total: 0
      },
      tableData: {
        rows: [],
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '',
      editFormData: {}
    }
  },
  mounted() {
    this.calculateTableHeight()
    this.handleGetList()
    window.addEventListener('resize', this.calculateTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight)
  },
  methods: {
    calculateTableHeight() {
      this.$nextTick(() => {
        const windowHeight = window.innerHeight
        this.tableHeight = windowHeight - 200
      })
    },
    
    handleSearchTypeChange() {
      this.searchKeywords = {
        name: '',
        disabled: ''
      }
    },
    
    async handleGetList() {
      try {
        const params = {
          page: this.pagination.page,
          rows: this.pagination.rows
        }
        
        const res = await getInsuranceClauseList(params)
        if (res && res.err_code === 0) {
          this.tableData = res
          this.pagination.total = res.total
        }
      } catch (error) {
        console.error('获取保险条款列表失败:', error)
      }
    },
    
    async handleSearch() {
      const params = {
        page: 1,
        rows: this.pagination.rows
      }
      
      if (this.searchType === '1' && this.searchKeywords.name) {
        params.name = this.searchKeywords.name
      } else if (this.searchType === '3' && this.searchKeywords.disabled !== '') {
        params.disabled = this.searchKeywords.disabled
      }
      
      try {
        const res = await getInsuranceClauseList(params)
        if (res && res.err_code === 0) {
          this.tableData = res
          this.pagination.total = res.total
          this.pagination.page = 1
        }
      } catch (error) {
        console.error('搜索保险条款失败:', error)
      }
    },
    
    handleShowAll() {
      this.searchKeywords = {
        name: '',
        disabled: ''
      }
      this.pagination.page = 1
      this.handleGetList()
    },
    
    handleAdd() {
      this.dialogTitle = '添加保险条款'
      this.editFormData = {}
      this.dialogVisible = true
    },
    
    handleEdit(row) {
      this.dialogTitle = '编辑保险条款'
      this.editFormData = { ...row }
      this.dialogVisible = true
    },
    
    async handleSave() {
      this.dialogVisible = false
      await this.handleGetList()
    },
    
    async handleToggleStatus(row, disabled) {
      const action = disabled ? '禁用' : '启用'
      try {
        await this.$confirm(`您确认想要修改 "${row.name}" 的状态为"${action}"吗？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await saveInsuranceClause({
          id: row.id,
          name: row.name,
          disabled: disabled
        })
        
        if (res && res.err_code === 0) {
          this.$message.success('修改成功')
          await this.handleGetList()
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('修改状态失败:', error)
          this.$message.error('修改失败')
        }
      }
    },
    
    async handleDelete(id) {
      try {
        await this.$confirm('您确定要删除该保险条款吗？', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await deleteInsuranceClause({ id })
        if (res && res.err_code === 0) {
          this.$message.success('删除成功')
          await this.handleGetList()
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }
    },
    
    async handleExport() {
      try {
        const params = {}
        if (this.searchType === '1' && this.searchKeywords.name) {
          params.name = this.searchKeywords.name
        } else if (this.searchType === '3' && this.searchKeywords.disabled !== '') {
          params.disabled = this.searchKeywords.disabled
        }
        
        const res = await getInsuranceClauseList(params)
        if (res && res.err_code === 0) {
          const tableMap = {
            name: '保险条款名称',
            created_at: '创建时间',
            updated_at: '更新时间'
          }
          const header = Object.values(tableMap)
          
          const data = res.rows.map(row => {
            return Object.keys(tableMap).map(key => {
              if (key.includes('_at')) {
                return this.formatDate(null, null, row[key])
              } else {
                return row[key]
              }
            })
          })
          
          data.unshift(header)
          
          const { export_xlsx } = await import('@/lib/execl')
          export_xlsx({ data, fileName: '保险条款列表' })
        }
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败')
      }
    },
    
    formatStatus(value) {
      if (value) {
        return <i style="font-size: 20px; color: #f56c6c" class="el-icon-error" />
      } else {
        return <i style="font-size: 20px; color: #67c23a" class="el-icon-success" />
      }
    },
    
    formatDate(value, row, cellValue) {
      if (!cellValue || +new Date(cellValue) < 0) {
        return '-'
      }
      return cellValue ? this.$day(cellValue).format('YYYY-MM-DD HH:mm:ss') : '-'
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  .filter-container {
    display: flex;
    align-items: center;
    
    .search-label {
      margin-right: 10px;
      font-size: 14px;
    }
    
    .right-buttons {
      margin-left: auto;
      
      .el-button {
        margin-left: 10px;
      }
    }
  }
}
</style>